<template>
  <v-container fluid>
    <my-modal ref="modalform" :dialog="dialogAlumnos" @close="close">
      <template v-slot:header> Agregar Alumnos </template>

      <template v-slot:body>
        <agregar-alumnos-cursado
          :cursado_id="cursado.id"
          @close="close"
        ></agregar-alumnos-cursado>
      </template>

      <template v-slot:footer-btn>
        <!--        <v-btn @click="agregar" color="blue darken-1" text> Agregar </v-btn>-->
      </template>
    </my-modal>

    <!-- Modal para inscribir en campus -->
    <v-dialog v-model="dialogCampus" max-width="600">
      <v-card>
        <v-card-title> Inscribir en Campus Virtual </v-card-title>
        <v-card-text>
          <div v-if="alumnoSeleccionado">
            <p>
              <strong>Alumno:</strong> {{ alumnoSeleccionado.alumno.apellido }},
              {{ alumnoSeleccionado.alumno.nombre }}
            </p>
            <p><strong>DNI:</strong> {{ alumnoSeleccionado.alumno.dni }}</p>
          </div>
          <v-alert v-else-if="selectedItems.length > 0" type="info" dense>
            Se inscribirán <strong>{{ selectedItems.length }}</strong> alumnos
            seleccionados
          </v-alert>
          <v-autocomplete
            v-model="ofertaIdSeleccionada"
            :items="ofertas"
            item-value="oferta_id"
            item-text="nombre_curso"
            label="Seleccionar Aula del Campus"
            outlined
            dense
            :loading="loadingOfertas"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nombre_curso }}</v-list-item-title>
                <v-list-item-subtitle
                  >ID: {{ item.oferta_id }} -
                  {{ item.nombre_categ }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCampus = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="inscribiendo"
            @click="inscribirEnCampus"
          >
            Inscribir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <slot name="dialog">
      <my-modal :eager="false" :dialog="dialog" @close="close">
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
          ><slot :name="slot" v-bind="scope"
        /></template>

        <template slot="header"><h3>AlumnoCursados</h3></template>
        <template slot="body">
          <v-form @submit.prevent="onSubmit">
            <slot name="other-form">
              <alumnoCursado-form :only="only">
                <template v-slot:fecha_abandono>
                  <div>
                    <vc-date-picker
                      v-if="abandono"
                      class=""
                      v-model="alumnoCursado.fecha_abandono"
                      :model-config="modelConfig"
                    >
                      <template v-slot="{ inputValue, togglePopover }">
                        <v-text-field
                          clearable
                          label="Seleccione Fecha de abandono"
                          :error-messages="errors.fecha_abandono"
                          :value="inputValue"
                          @click="togglePopover"
                          @click:clear="alumnoCursado.fecha_abandono = null"
                        />
                      </template>
                    </vc-date-picker>
                  </div>
                </template>
                <template v-slot:observaciones>
                  <v-textarea
                    label="Ingrese Las Observaciones"
                    v-model="alumnoCursado.observaciones"
                  ></v-textarea>
                </template>
              </alumnoCursado-form>
            </slot>
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
              ><slot :name="slot" v-bind="scope"
            /></template>
          </v-form>
        </template>
        <template v-slot:footer-btn>
          <v-btn color="blue darken-1" text @click="onSubmit"> Guardar </v-btn>
        </template>
      </my-modal>
    </slot>
    <h4>{{ cursado.carrera.nombre }}</h4>
    <h5>Alumnos de {{ cursado.espacio.nombre }}</h5>
    <div>
      <span>Comision: {{ cursado.comision }}</span>
    </div>
    <div>
      <span v-for="horario in cursado.horarios" :key="horario.id"
        >{{ horario.nombreDia }} de {{ horario.hora_inicio }} hasta
        {{ horario.hora_fin }}</span
      >
    </div>
    <!-- Info del Aula Campus -->
    <v-alert
      v-if="cursado.aulaCampusUrl"
      dense
      outlined
      type="info"
      class="mt-2"
    >
      <div class="d-flex align-center">
        <span class="mr-3">
          <strong>Aula Campus:</strong>
          <a :href="cursado.aulaCampusUrl" target="_blank">
            {{ cursado.aulaCampusUrl }}
          </a>
        </span>
        <v-btn small color="orange" dark @click="abrirModalCampusMasivo">
          <v-icon small left>mdi-account-multiple-plus</v-icon>
          Inscribir Seleccionados
        </v-btn>
      </div>
    </v-alert>
    <v-row no-gutters align="center">
      <div class="pr-3">
        <v-btn @click="showAgregar" outlined color="primary">Agregar</v-btn>
      </div>
      <div class="pr-3">
        <v-switch label="Editar" v-model="disableNotas" />
      </div>
      <div class="mr-3">
        <alumno-cursado-p-d-f
          ref="pdf"
          :cursado="cursado"
          :items="alumnoCursados"
        ></alumno-cursado-p-d-f>
        <div v-if="$refs.pdf">
          <v-btn outlined color="dark" @click="$refs.pdf.generateReport"
            >Exportar</v-btn
          >
        </div>
      </div>

      <div>
        <v-btn color="warning" @click="enviarMail">Enviar Mail</v-btn>
      </div>

      <import-export
        class="mr-3"
        model-class="AlumnoCursados"
        :path="uploadPath"
        :model-fields="fields"
        :plantilla="[alumnoCursado]"
        :only="importOnly"
        @close="close"
      ></import-export>
      <div class="mr-3">
        <v-btn @click="deleteAll" outlined color="error">Borrar Todo</v-btn>
      </div>
    </v-row>

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <v-data-table
      :options.sync="options"
      :server-items-length="pagination.totalCount"
      v-model="selectedItems"
      :show-select="true"
      :items="alumnoCursados"
      :headers="headers"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
        ><slot :name="slot" v-bind="scope"
      /></template>

      <template v-slot:item.tp1="{ item }">
        <v-switch
          :disabled="!disableNotas"
          :label="item.tp1 ? 'SI' : 'NO'"
          v-model="item.tp1"
        ></v-switch>
      </template>
      <template v-slot:item.tp2="{ item }">
        <v-switch
          :disabled="!disableNotas"
          :label="item.tp2 ? 'SI' : 'NO'"
          v-model="item.tp2"
        ></v-switch>
      </template>
      <template v-slot:item.tp3="{ item }">
        <v-switch
          :disabled="!disableNotas"
          :label="item.tp3 ? 'SI' : 'NO'"
          v-model="item.tp3"
        ></v-switch>
      </template>
      <template v-slot:item.tp4="{ item }">
        <v-switch
          :disabled="!disableNotas"
          :label="item.tp4 ? 'SI' : 'NO'"
          v-model="item.tp4"
        ></v-switch>
      </template>

      <template v-slot:item.nota_alumno="{ item }">
        <v-text-field
          @change="updateAlumnoCursado(item)"
          :disabled="!disableNotas"
          type="number"
          v-model="item.nota_alumno"
        ></v-text-field>
      </template>

      <template v-slot:item.cursado_aprobado="{ item }">
        <v-switch
          :true-value="1"
          :false-value="0"
          @change="updateAlumnoCursado(item)"
          :disabled="!disableNotas"
          :label="item.cursado_aprobado ? 'SI' : 'NO'"
          v-model="item.cursado_aprobado"
        ></v-switch>
      </template>

      <template v-slot:item.fecha_abandono="{ item }">
        <v-row>
          <v-btn
            @click="editAbandono(item, true)"
            :color="item.fecha_abandono ? 'error' : 'light'"
            >{{
              item.fecha_abandono ? item.fecha_abandono : "registrar"
            }}</v-btn
          >
        </v-row>
      </template>

      <template v-slot:item.observaciones="{ item }">
        <v-icon color="info" class="mr-2" @click="editAbandono(item, false)">
          mdi-pencil
        </v-icon>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          x-small
          color="orange"
          dark
          class="mr-1"
          @click="abrirModalCampus(item)"
          :title="
            item.ofertaIdCampusSugerido
              ? 'Aula sugerida: ' + item.ofertaIdCampusSugerido
              : 'Sin aula sugerida'
          "
        >
          <v-icon x-small left>mdi-school</v-icon>
          Campus
        </v-btn>
        <v-icon color="info" @click="deleteItem(item.id)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {
  // mapGetters,
  mapActions,
  mapGetters,
  mapState,
} from "vuex";
import AlumnoCursadoForm from "@/views/alumno-cursado/AlumnoCursadoForm";
import MyModal from "@/components/templates/MyModal";
import AlumnoCursadoPDF from "@/views/alumno-cursado/pdf/AlumnoCursadoPDF";
import AgregarAlumnosCursado from "@/views/alumno-cursado/AgregarAlumnosCursado";
import ImportExport from "@/views/layouts/ImportExport";
import AlumnoCursado from "@/apis/AlumnoCursado";
import Campus from "@/apis/Campus";

export default {
  name: "AlumnoCursadoABM",
  components: {
    AgregarAlumnosCursado,
    AlumnoCursadoPDF,
    ImportExport,
    MyModal,
    AlumnoCursadoForm,
  },
  props: {
    cursada_id: [String, Number],
    uploadPath: { type: String, default: "alumno-cursados" },
    headers: Array,
    only: Array,
  },
  data() {
    return {
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD", // Uses 'iso' if missing
      },
      abandono: true,
      awaitingSearch: null,
      filters: {},
      options: { itemsPerPage: -1 },
      importOnly: ["alumno_id", "cursado_id"],
      disableNotas: false,
      filterAlumno: "",
      selected: [],
      dialogAlumnos: false,
      selectedItems: [],
      search: "",
      // Campus inscription
      dialogCampus: false,
      ofertas: [],
      loadingOfertas: false,
      inscribiendo: false,
      ofertaIdSeleccionada: null,
      alumnoSeleccionado: null,
    };
  },
  methods: {
    ...mapActions("AlumnoCarreraModule", ["getAlumnosPorCarrera"]),
    ...mapActions("AlumnoCursadoModule", [
      "sendMailNota",
      "getAlumnoCursadosPorCursado",
      "getAlumnoCursados",
      "getFields",
      "addAlumnoCursado",
      "updateAlumnoCursado",
      "deleteAlumnoCursado",
      "editAlumnoCursado",
      "showDialog",
      "hideDialog",
    ]),
    ...mapActions("CursadoModule", ["getCursado"]),

    async enviarMail() {
      await this.sendMailNota(this.selectedItems);
      this.reload();
    },

    close() {
      this.hideDialog();
      this.dialogAlumnos = false;
      this.selected = [];
      this.reload();
    },
    showAgregar() {
      this.dialogAlumnos = true;
      this.getAlumnosPorCarrera(this.cursado.carrera.id);
    },
    agregar() {
      for (var i in this.selected) {
        var alumnoCursado = {};
        alumnoCursado.alumno_id = this.selected[i];
        alumnoCursado.cursado_id = this.cursado.id;
        this.addAlumnoCursado(alumnoCursado);
      }
    },
    onSubmit() {
      // this.addAlumnoCursado(this.alumnoCursado);
      this.alumnoCursado.id
        ? this.updateAlumnoCursado(this.alumnoCursado)
        : this.addAlumnoCursado(this.alumnoCursado);
      this.close();
    },
    newItem() {
      // this.fetchAlumnoCursado();
      this.editAlumnoCursado({});
      this.showDialog();
    },
    editItem(item) {
      this.editAlumnoCursado(item);
      this.showDialog();
      // this.showAlumnoCursadoDialog();
    },
    deleteItem(id) {
      this.deleteAlumnoCursado(id);
    },
    async deleteAll() {
      await AlumnoCursado.deleteAll(this.selectedItems);
      this.selectedItems = [];
      this.reload();
    },

    reload() {
      this.getAlumnoCursadosPorCursado({
        filters: this.filters,
        options: this.options,
      });
      this.selectedItems = [];
    },

    editAbandono(item, flag) {
      this.abandono = flag;
      this.editItem(item);
    },

    async abrirModalCampus(item) {
      this.alumnoSeleccionado = item;
      this.ofertaIdSeleccionada = item.ofertaIdCampusSugerido || null;
      this.dialogCampus = true;

      // Cargar ofertas si no están cargadas
      if (this.ofertas.length === 0) {
        this.loadingOfertas = true;
        try {
          const response = await Campus.getOfertas();
          if (response.success) {
            this.ofertas = response.ofertas;
          }
        } catch (error) {
          console.error("Error cargando ofertas:", error);
        }
        this.loadingOfertas = false;
      }
    },

    async inscribirEnCampus() {
      if (!this.ofertaIdSeleccionada) {
        this.$dialog.error({
          text: "Debe seleccionar un aula del campus",
          title: "Error",
        });
        return;
      }
      "notaAlumnoCursado", "ofertaIdCampusSugerido";
      this.inscribiendo = true;

      // Si hay un solo alumno seleccionado
      if (this.alumnoSeleccionado) {
        try {
          const response = await Campus.inscribir(
            this.alumnoSeleccionado.alumno.dni,
            this.ofertaIdSeleccionada
          );

          if (response.success) {
            this.$dialog.message.success("Inscripcion exitosa en el campus", {
              position: "top-right",
            });
            this.dialogCampus = false;
            this.reload();
          } else {
            this.$dialog.error({
              text: response.error || "Error al inscribir en el campus",
              title: "Error",
            });
          }
        } catch (error) {
          this.$dialog.error({
            text:
              error.response?.data?.error || "Error al inscribir en el campus",
            title: "Error",
          });
        }
      } else if (this.selectedItems.length > 0) {
        // Inscripción masiva
        let exitosos = 0;
        let fallidos = 0;

        for (const item of this.selectedItems) {
          try {
            const response = await Campus.inscribir(
              item.alumno.dni,
              this.ofertaIdSeleccionada
            );
            if (response.success) {
              exitosos++;
            } else {
              fallidos++;
            }
          } catch (error) {
            fallidos++;
          }
        }

        this.$dialog.message.success(
          `Inscripción completada: ${exitosos} exitosos, ${fallidos} fallidos`,
          { position: "top-right" }
        );
        this.dialogCampus = false;
        this.selectedItems = [];
        this.reload();
      }

      this.inscribiendo = false;
    },

    async abrirModalCampusMasivo() {
      if (this.selectedItems.length === 0) {
        this.$dialog.warning({
          text: "Debe seleccionar al menos un alumno",
          title: "Atención",
        });
        return;
      }

      this.alumnoSeleccionado = null;
      this.ofertaIdSeleccionada = this.cursado.ofertaIdCampus || null;
      this.dialogCampus = true;

      // Cargar ofertas si no están cargadas
      if (this.ofertas.length === 0) {
        this.loadingOfertas = true;
        try {
          const response = await Campus.getOfertas();
          if (response.success) {
            this.ofertas = response.ofertas;
          }
        } catch (error) {
          console.error("Error cargando ofertas:", error);
        }
        this.loadingOfertas = false;
      }
    },
  },

  computed: {
    ...mapGetters("AlumnoCursadoModule", ["errors"]),
    ...mapState("AlumnoCarreraModule", ["alumnoCarreras"]),
    ...mapState("AlumnoCursadoModule", [
      "pagination",
      "alumnoCursados",
      "dialog",
      "alumnoCursado",
      "fields",
    ]),
    ...mapState("CursadoModule", ["cursado"]),
    filteredAlumnos() {
      return this.alumnoCarreras.filter(
        (a) => !this.alumnoCursados.map((b) => b.alumno_id).includes(a.id)
      );
    },
    // ...mapGetters("AlumnoCursadoModule",["alumnoCursadoList","alumnoCursadoDialog","newAlumnoCursadoRecord","alumnoCursado","alumnoCursadoFields","alumnoCursadoErrors"]),
    // ...mapGetters("AlumnoCursadoModule",["errors"]),
  },
  watch: {
    options: {
      handler() {
        this.reload();
        // console.log(this.pagination);
      },
      deep: true,
    },
    filters: {
      handler() {
        this.reload();
        // console.log(this.pagination);
      },
      deep: true,
    },
    search: function () {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.reload();
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
  },
  created() {
    this.filters.cursado_id = this.cursada_id;
    this.getCursado(this.cursada_id);
    this.getFields();
  },
};
</script>

<style scoped></style>
